enum LOGIN_METHOD {
	LOGIN_FORM = 'LOGIN_FORM',
	COOKIES = 'COOKIES'
}

export { LOGIN_METHOD };
